module.exports = __webpack_public_path__ + "static/media/poi~DwieAQSm.997d1bbd.svg";